import React from 'react';

export default function TriageIcon() {
  return (
    <svg
      fill="none"
      height="200"
      viewBox="0 0 200 200"
      width="200"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 200c55.229 0 99.999-44.772 99.999-100 0-55.229-44.77-100-99.999-100C44.772 0 0 44.771 0 100c0 55.228 44.772 100 100 100z"
        fill="#8D65B5"
      />
      <mask
        height="200"
        id="mask0_1902_7028"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="200"
        x="0"
        y="0"
      >
        <path
          d="M100 200c55.228 0 99.999-44.772 99.999-100 0-55.229-44.771-100-100-100C44.772 0 0 44.771 0 100c0 55.228 44.771 100 100 100z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#mask0_1902_7028)">
        <path
          d="M136.975 6.96L3.967 64.573 80.47 241.195l133.008-57.614L136.975 6.96z"
          fill="#59377B"
        />
        <path
          d="M139.856-.083L6.847 57.53l76.505 176.621 133.008-57.612L139.856-.083z"
          fill="#F50B7C"
        />
        <path
          clipRule="evenodd"
          d="M209.339 180.67L90.872 231.978 17.862 62.529l118.461-51.302 73.016 169.443z"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          d="M91.188 9.978l-8.743 3.787a14.413 14.413 0 00-.822-2.538C78.431 3.86 69.868.474 62.501 3.66c-7.367 3.192-10.753 11.755-7.567 19.122.36.835.801 1.61 1.289 2.338l-8.71 3.773c-4.795 2.078-7.006 7.641-4.936 12.444l5.437 12.63 61.067-26.45-5.417-12.59c-2.07-4.815-7.66-7.033-12.47-4.949h-.006zm-25.194 1.75a4.05 4.05 0 015.33 2.11 4.05 4.05 0 01-2.11 5.33 4.05 4.05 0 01-5.33-2.11 4.05 4.05 0 012.11-5.33z"
          fill="#FF9F00"
        />
        <path
          d="M87.011 142.374l-19.183 8.309 8.31 19.184 19.182-8.31-8.309-19.183zM102.647 178.463l-19.184 8.31 8.31 19.183 19.183-8.309-8.309-19.184zM71.454 106.458l-19.183 8.309 8.309 19.184 19.183-8.31-8.31-19.183z"
          fill="#A381C5"
        />
        <path
          d="M61.623 122.528l5.01 1.256 1.83-8.47M77.212 158.528l5.016 1.263 1.83-8.469M92.81 194.535l5.008 1.256 1.837-8.47"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.994"
        />
        <path
          d="M83.15 113.952l69.838-30.417M98.36 148.303l69.836-30.41M114.13 184.91l69.837-30.409"
          stroke="#59377B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M3.804 64.166l2.878-7.053s4.756 4.541 4.442 5.163c-.314.62-7.327 1.89-7.327 1.89h.007z"
          fill="#59377B"
        />
        <path d="M8.8 62.002l-4.996 2.164 15.903 36.721 5.003-2.157L8.8 62.002z" fill="#59377B" />
        <path
          d="M152.815 43.5l5.002-2.157-18.12-41.838L6.682 57.113 8.8 62.002 136.818 6.558l15.997 36.943z"
          fill="#F50B7C"
        />
        <path
          d="M32.164 95.517L17.697 62.115l118.467-51.302 14.548 33.596 2.103-.908-15.996-36.943L8.8 62.002 24.71 98.73l7.454-3.213z"
          fill="#F50B7C"
        />
        <path
          d="M136.165 10.813L17.697 62.115l14.467 33.402L150.712 44.41l-14.547-33.596z"
          fill="#fff"
        />
        <path
          d="M91.026 9.564l-8.743 3.787a14.391 14.391 0 00-.822-2.538C78.27 3.446 69.706.06 62.34 3.246 54.972 6.438 51.586 15 54.772 22.368c.36.835.8 1.61 1.288 2.338l-8.71 3.773c-4.795 2.078-7.005 7.641-4.935 12.444l5.437 12.63 61.067-26.45-5.417-12.59c-2.07-4.815-7.66-7.033-12.47-4.949h-.006zm-25.194 1.75a4.05 4.05 0 015.33 2.11 4.05 4.05 0 01-2.11 5.33 4.05 4.05 0 01-5.33-2.11 4.05 4.05 0 012.11-5.33z"
          fill="#FF9F00"
        />
        <path
          clipRule="evenodd"
          d="M103.455 59.05l-9.418 4.08-4.08-9.417-7.535 3.266 4.081 9.418-9.418 4.074 3.26 7.534 9.418-4.075 4.08 9.418 7.534-3.266-4.08-9.417 9.417-4.075-3.259-7.54z"
          fill="#F50B7C"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
}
